import { render, staticRenderFns } from "./SuccessDonation.vue?vue&type=template&id=5aa71092&scoped=true"
import script from "./SuccessDonation.vue?vue&type=script&lang=js"
export * from "./SuccessDonation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa71092",
  null
  
)

export default component.exports